import {
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { RepositoryFirebase } from "../common/repository.firebase";
import { CashSession } from "./cash-session.entity";

class CashSessionRepository extends RepositoryFirebase<CashSession> {
  static readonly instance = new CashSessionRepository();

  protected collection = "cash-sessions";
  protected entity = CashSession;

  async findOpenSession(): Promise<CashSession | null> {
    const ref = this.getCollection();
    const q = query(ref, where("status", "==", "open"), limit(1));
    const snap = await getDocs(q);
    if (snap.empty) return null;
    const doc = snap.docs[0];
    return CashSession.build(doc.id, doc.data() as Record<string, unknown>);
  }

  subscribeOpenSession(onNext: (session: CashSession | null) => void): () => void {
    const ref = this.getCollection();
    const q = query(ref, where("status", "==", "open"), limit(1));
    return onSnapshot(
      q,
      async (snap) => {
        if (snap.empty) {
          onNext(null);
          return;
        }
        const doc = snap.docs[0];
        const session = await CashSession.build(
          doc.id,
          doc.data() as Record<string, unknown>
        );
        onNext(session);
      },
      () => onNext(null)
    );
  }

  /** Sessões recentes (abertas e fechadas) por data de abertura */
  async listRecentSessions(maxCount = 40): Promise<CashSession[]> {
    const ref = this.getCollection();
    const q = query(ref, orderBy("openedAt", "desc"), limit(maxCount));
    const snap = await getDocs(q);
    return Promise.all(
      snap.docs.map((d) =>
        CashSession.build(d.id, d.data() as Record<string, unknown>)
      )
    );
  }
}

export const cashSessionRepository = CashSessionRepository.instance;
